import assessmentConf from './assessmentConf'
import assessmentVersion from './version'

export default {
  assessmentConf: assessmentConf,
  assessmentVersion: assessmentVersion
}